// import { Modal } from "flowbite-react";
import { useEffect, useState } from "react";
import Breadcrumb from "../common/components//Breadcrumb";
import CenteredLoader from "../common/components//CenteredLoader";
import AuthProvider from "../common/services/auth/AuthProvider/Index";
import { mergeErrors } from "../common/utils";
import { Button } from "../common/components/Form/Button";
// import { defaultModalTheme } from "../common/flowbyte";
// import { Checkbox } from "../common/components/Form/Checkbox";
import { useNavigate } from 'react-router-dom';

interface HistoryProps {
  className?: string;
}

interface HistoryData {
  tracking_number: string;
  serial_number: string;
  lot_number: string;
  status: string;
  claim_timestamp: number;
  results_timestamp: number;
}

const fetchResults = async (serialNumber: string) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/private/semen-analysis-kits/${serialNumber}/results`;

    const response = await fetch(apiUrl, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await AuthProvider.getValidAuthorizationToken()}`,
      },
      method: "GET",
    });

    if (!response.ok) {
      if (response.status === 422) {
        const result = await response.json();

        throw new Error(
          `Validation error: ${JSON.stringify(mergeErrors(result.errors))}.`
        );
      } else {
        throw new Error("Failed to load resource.");
      }
    }

    if (response.ok) {
      const result = await response.json();

      return result.data;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }

  return null;
};

const History: React.FC<HistoryProps> = () => {
  const navigate = useNavigate();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [selectedHistory, setSelectedHistory] = useState<HistoryData | null>(
  //   null
  // );
  // const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resultLoading, setResultLoading] = useState(false);
  const [historyData, setHistoryData] = useState<HistoryData[]>([]);
  // const [setResults] = useState<any>(null);

  useEffect(() => {
    setLoading(true);

    async function fetchData() {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/v1/private/semen-analysis-kits/completed`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${await AuthProvider.getValidAuthorizationToken()}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setHistoryData(data.data);
        } else {
          console.error("Failed to fetch data from the API");
        }
      } catch (error) {
        console.error("Error while fetching data:", error);
      }
    }

    fetchData().then(() => {
      setLoading(false);
    });
  }, []);

  return (
    <>
      {/* {!loading && selectedHistory && (
        <>
          <Modal
            theme={defaultModalTheme}
            className="rounded-t-none rounded-b-none"
            show={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          >
            <Modal.Header>
              Analysis performed on{" "}
              {selectedHistory &&
                new Date(
                  selectedHistory.results_timestamp * 1000
                ).toLocaleDateString(navigator.language, {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
            </Modal.Header>
            <Modal.Body>
              <div className="">
                <p className="text-base leading-relaxed font-bold text-gray-950 mb-6 mt-6">
                  Please accept the terms and conditions so we can display the
                  results
                </p>
                <Checkbox
                  label="I understand and accept that by exporting or printing my medical
          exam results, I take full responsibility for the security of my
          personal medical data, as once it is outside the system, CARE FOR
          THERE LLC cannot guarantee its protection to comply with HIPAA
          (Health Insurance Portability and Accountability Act) privacy
          regulations. I agree that any unauthorized disclosure of this
          information is at my own risk."
                  name="agree"
                  checked={checked}
                  disabled={loading}
                  onChange={async () => {
                    if (!checked) {
                      setChecked(!checked);
                    } else {
                      setChecked(!checked);
                      setResults(null);
                      setResultLoading(false);
                    }
                  }}
                />
                  <CenteredLoader className="flex mt-12 mb-12" />
              </div>
            </Modal.Body>
            <Modal.Footer>
            <Button
                label="Confirm"
                theme="primary"
                className="inline-flex items-center px-12 py-2.5 mt-6 mr-2 font-medium "
                disabled={!checked || resultLoading}
                onClick={async () => {
                  setResultLoading(true);
                  const resultsFromApi = await fetchResults(
                    selectedHistory.serial_number
                  );
                  navigate('/results', { state: { data: resultsFromApi } });
                }}
              />
              <Button
                label="Close"
                theme="secondary"
                className="inline-flex items-center px-12 py-2.5 mt-6 font-medium "
                onClick={() => {
                  setIsModalOpen(false);
                  setChecked(false);
                }}
              />
            </Modal.Footer>
          </Modal>
        </>
      )} */}
      <div className={`w-full xl:w-3/4 min-h-screen bg-gray-100 text-gray-900`}>
        <main className="mx-auto px-4 sm:px-6 lg:px-8 pt-4">
          <Breadcrumb
            pages={[
              { name: "Test Results", href: "#", current: true },
            ]}
          />

          <div className="mt-8">
            <h1 className="text-xl font-semibold">View My Test Results</h1>
          </div>

          <div className="mt-6 pb-12 mb-12">
            {(loading || resultLoading) && (
              <div className="mt-8 flow-root bg-white">
                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div className="overflow-hidden shadow">
                      <CenteredLoader className="flex mt-24 mb-24 bg-white" />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {!loading && (
              <div className="mt-8 flow-root">
                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5">
                      <table className="min-w-full divide-y divide-gray-300">
                        <thead className="bg-gray-50">
                          <tr>
                            <th
                              scope="col"
                              className="hidden sm:flex py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                            >
                              Test Type
                            </th>
                            <th
                              scope="col"
                              className="relative text-sm font-semibold text-gray-900 py-3.5 pl-3 pr-4 sm:pr-6"
                            >
                              Kit Number
                            </th>
                            <th
                              scope="col"
                              className="hidden sm:flex relative text-sm font-semibold text-gray-900 py-3.5 pl-3 pr-4 sm:pr-6"
                            >
                              Analysis Date
                            </th>
                            <th
                              scope="col"
                              className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                            >
                              <span className="sr-only">Actions</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white ">
                          {historyData.map((item) => (
                            <tr key={item.serial_number}>
                              <td className="hidden sm:flex py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                Post Vasectomy
                              </td>
                              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                {item.serial_number}
                              </td>
                              <td className="hidden sm:flex py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                              {item.status === "preparingForShippingToLab" ? ( <span>Pending</span> ) : (
                                new Date(
                                  item.results_timestamp * 1000
                                ).toLocaleDateString(navigator.language, {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                })
                              )}
                              </td>
                              <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                              {item.status === "preparingForShippingToLab" ? (
                                <Button
                                  label="Pending"
                                  theme="primary"
                                  className="inline-flex items-center px-12 py-2.5 mt-6 mb-6 font-medium text-center"
                                  disabled={true}
                                />
                              ) : (
                                <Button
                                  label="View Results"
                                  theme="primary"
                                  className="inline-flex items-center px-12 py-2.5 mt-6 mb-6 font-medium text-center"
                                  disabled={resultLoading}
                                  onClick={async () => {
                                    setResultLoading(true);
                                    const resultsFromApi = await fetchResults(
                                      item.serial_number
                                    );
                                    navigate('/results', { state: { data: resultsFromApi } });
                                  }}
                                />
                              )}
                              </td>
                            </tr>
                          ))}
                          {!historyData.length && (
                            <tr>
                              <td
                                colSpan={4}
                                className="relative whitespace-nowrap py-4 pl-3 pr-4 text-center text-sm font-medium sm:pr-6 pt-12 pb-12"
                              >
                                No previous analysis found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </main>
      </div>
    </>
  );
};

export default History;
